(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["video-lazy"] && !Shopify.designMode) return;
  try {
    

document.addEventListener("DOMContentLoaded", function() {
  var lazyVideos = [].slice.call(document.querySelectorAll("video.lazy"));

  if ("IntersectionObserver" in window) {
    var lazyVideoObserver = new IntersectionObserver(function(entries, observer) {
      entries.forEach(function(video) {
        if (video.isIntersecting) {
          for (var source in video.target.children) {
            var videoSource = video.target.children[source];
            if (typeof videoSource.tagName === "string" && videoSource.tagName === "SOURCE") {
              videoSource.src = videoSource.dataset.src;
            }
          }

          video.target.load();
          video.target.classList.remove("lazy");
          lazyVideoObserver.unobserve(video.target);
        }
      });
    });

    lazyVideos.forEach(function(lazyVideo) {
      lazyVideoObserver.observe(lazyVideo);
    });
  }
});
  
$(document).ready(function(){
  $("video").prop('muted', true);

  $(".sound-button").click( function (){
      $("video").prop('muted', !$("video").prop('muted'));
      $("#off-line").toggleClass("hidden-sound")
  });
});

// after 9 seconds, stop looping the video
setTimeout(function(){
    const video = document.getElementById('nuts_dancing');
    video.removeAttribute("loop");

    // optional: go back to the poster image when the video completes
    video.removeAttribute("autoplay"); // remove autoplay too so it doesn't start again;
    video.addEventListener('ended', function() { video.load(); });
}, 45000);  
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video"] && !Shopify.designMode) return;
  try {
    

$(document).ready(function(){
  $("video").prop('muted', true);

  $(".sound-button").click( function (){
      $("video").prop('muted', !$("video").prop('muted'));
      $("#off-line").toggleClass("hidden-sound")
  });
});

// after 9 seconds, stop looping the video
setTimeout(function(){
    const video = document.getElementById('nuts_dancing');
    video.removeAttribute("loop");

    // optional: go back to the poster image when the video completes
    video.removeAttribute("autoplay"); // remove autoplay too so it doesn't start again;
    video.addEventListener('ended', function() { video.load(); });
}, 45000);  
  

  } catch(e) { console.error(e); }
})();
})();
